﻿import { TypeaheadLocationType } from 'features/searchResultsFacets';

/**
 * This function returns true if the product type is homes
 * @param state - The state of the Redux store.
 */
export const isProductTypeHomes = (state) => state?.searchParameters?.product?.productType === 'homes';

/**
 * If the state has a searchParameters property, and that property has a Location property, and the location type is
 * different than rectangular area return true, otherwise false.
 *
 * @param state - The state of the Redux store.
 */
export const isSearchWithinMapDisabled = (state) =>
  state?.searchParameters?.location?.locationType !== 'rectangularArea';

/**
 * If the state has a searchParameters property, and that property has a Location property, return
 * that property. Otherwise, return undefined.
 *
 * @param state - The state of the Redux store.
 */
export const locationSearchParameters = (state) => state?.searchParameters?.location;

/**
 * returns true is the current location type is community
 *
 * @param state - The state of the Redux store.
 */
export const isNotCommunityLocationType = (state) =>
  state?.searchParameters?.location?.locationType !== TypeaheadLocationType.Community.toString();

/**
 * If the state has a searchParameters property return that property with informaiton of the facts return it.
 * Otherwise, return undefined.
 * It refers to the type of facts of the housing unit, for example, price, bedrooms, etc.
 *
 * @param state - The state of the Redux store.
 */
export const factsSearchParameters = (state) => state?.searchParameters?.facts;

/**
 * If the state has a searchParameters property that has information about the product to display return it.
 * Otherwise, return undefined.
 * It refers to the type of product to display, for example, homes, communities, custom.
 *
 * @param state - The state of the Redux store.
 */
export const productSearchParameters = (state) => state?.searchParameters?.product;

/**
 * If the state has a searchParameters property with information of the features return it.
 * Otherwise, return undefined.
 *
 * It Refers to the type of features from the housing development, for example, pool, waterfront, etc.
 *
 * @param state - The state of the Redux store.
 */
export const featuresSearchParameters = (state) => state?.searchParameters?.features;
